import React from 'react';
import { Box, Button, Menu, MenuItem } from '@mui/material';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';

interface DesktopNavProps {
  onNavigate: (route: string) => void;
  onServicesClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  anchorElServices: HTMLButtonElement | null;
  onServicesClose: () => void;
}

const pages = ['Home', 'Services', 'Locations', 'Check Balance', 'Schedule Now'];

const DesktopNav: React.FC<DesktopNavProps> = ({
  onNavigate,
  onServicesClick,
  anchorElServices,
  onServicesClose,
}) => {
  return (
    <Box sx={{ display: { xs: 'none', sm: 'flex' } }}>
      {pages.map((page) =>
        page === 'Services' ? (
          <Box key={page}>
            <Button
              sx={{ ml: 2, color: 'text.primary', display: 'flex', alignItems: 'center' }}
              onClick={onServicesClick}
              endIcon={anchorElServices ? <ExpandLess /> : <ExpandMore />}
            >
              Services
            </Button>
            <Menu
              anchorEl={anchorElServices}
              open={Boolean(anchorElServices)}
              onClose={onServicesClose}
              MenuListProps={{
                'aria-labelledby': 'services-button',
              }}
            >
              <MenuItem onClick={() => { window.open('https://www.mylaundryorder.com/?s=1740758514200x273776307348996480', '_blank', 'width=600,height=800'); onServicesClose(); }}>
                Order Now
              </MenuItem>
              <MenuItem onClick={() => { onNavigate('/all-services'); onServicesClose(); }}>
                All Services
              </MenuItem>
              <MenuItem onClick={() => { onNavigate('/menu-dropoff'); onServicesClose(); }}>
                Wash & Fold Prices (Drop Off)
              </MenuItem>
            </Menu>
          </Box>
        ) : (
          <Button
            key={page}
            sx={{
              fontWeight: page === 'Schedule Now' ? 'bold' : 'normal',
              color: 'text.primary',
              backgroundColor: page === 'Schedule Now' ? 'rgba(0,0,0,0.1)' : 'transparent',
              ml: 2,
            }}
            onClick={() => {
              if (page === 'Check Balance') {
                window.open('https://my.laundroworks.com/', '_blank', 'width=600,height=800');
              } else if (page === 'Schedule Now') {
                window.open(
                  'https://www.mylaundryorder.com/?s=1740758514200x273776307348996480',
                  '_blank',
                  'width=600,height=800'
                );
              } else {
                onNavigate(
                  page.toLowerCase() === 'home' ? '/' : `/${page.toLowerCase().replace(' ', '-')}`
                );
              }
            }}
          >
            {page}
          </Button>
        )
      )}
    </Box>
  );
};

export default DesktopNav;
